import ScalarCopyButton_vue_vue_type_script_setup_true_lang_default from "./ScalarCopyButton.vue.script.js";
//#region src/components/ScalarCopy/ScalarCopyButton.vue
var ScalarCopyButton_default = ScalarCopyButton_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCopyButton_default as default };

//# sourceMappingURL=ScalarCopyButton.vue.js.map